import React from "react";
import { withTranslation } from "react-i18next";
import FieldGroup from "./FieldGroup";

const DomainName = ({ value, handleChange, t, required = false }) => (
  <FieldGroup
    id="domainName"
    type="text"
    label={t('form.fields.domainName.label')}
    placeholder={t('form.fields.domainName.placeholder')}
    value={value}
    onChange={handleChange}
    pattern="^((?!-)[A-Za-z0-9\-]{1,63}(?<!-)\.)+[A-Za-z]{2,20}$"
    required={required}
  />
);

export default withTranslation()(DomainName);



// WEBPACK FOOTER //
// ./src/components/DomainName.js